import { Listbox, Transition } from '@headlessui/react'
import { first } from 'lodash';
import { useEffect } from 'react';

// Reports the Listbox's open/closed state to the caller (e.g. so a draggable row containing this
// dropdown can suppress dragging while it's open) - a plain child of the render-prop JSX below,
// since `open` is only available inside that render prop.
function OpenStateReporter({ open, onOpenChange }) {
    useEffect(() => {
        onOpenChange(open)
    }, [open, onOpenChange])
    return null
}

export function Dropdown({
    options,
    selectedOption,
    onChange,
    onOpenChange,
    hasError,
    mauto,
    disabled,
    placeholder,
}) {

    if (!selectedOption) {
        selectedOption = first(options)
    }

    return (
        <Listbox
            value={selectedOption}
            by="key"
            onChange={(newSelectedOption) => {
                if (newSelectedOption.key === selectedOption.key) {
                    return
                }
                onChange(newSelectedOption)
            }}
            disabled={disabled ? disabled : selectedOption.disable}>
            {({ open }) => (
                <>
                    {onOpenChange && <OpenStateReporter open={open} onOpenChange={onOpenChange} />}
                    <div
                        className={
                            hasError
                                ? 'prism-select prism-select-md outline-error'
                                : 'prism-select prism-select-md'
                        }>
                        <Listbox.Button
                            className="prism-select__toggle form-control"
                            mauto={mauto ? mauto : 'N/A'}>
                            { !!placeholder ? placeholder : selectedOption ? selectedOption.name : ''}
                        </Listbox.Button>
                        <Transition
                            show={open}
                            enter="transition duration-100 ease-out"
                            enterFrom="transform scale-95 opacity-0"
                            enterTo="transform scale-100 opacity-100"
                            leave="transition duration-75 ease-out"
                            leaveFrom="transform scale-100 opacity-100"
                            leaveTo="transform scale-95 opacity-0">
                            <Listbox.Options static as="div">
                                <div className="prism-select__menu-open">
                                    {options.map((op) => (
                                        <Listbox.Option
                                            key={op.key}
                                            value={op}
                                            disabled={op.disable}
                                            as="div">
                                            {({
                                                active,
                                                selected,
                                                disabled
                                            }) => (
                                                <button
                                                    type="button"
                                                    disabled={op.disable}
                                                    className={`prism-select__option ${
                                                        active ? 'active' : ''
                                                    } ${
                                                        selected
                                                            ? 'prism-select__option-selected'
                                                            : ''
                                                    } ${
                                                        disabled
                                                            ? 'prism-select__option-disabled'
                                                            : ''
                                                    } `}>
                                                    <span
                                                        className={`prism-select__label ${
                                                            active
                                                                ? 'active'
                                                                : ''
                                                        } ${
                                                            selected
                                                                ? 'active'
                                                                : ''
                                                        } `}>
                                                        {op.name}
                                                    </span>
                                                </button>
                                            )}
                                        </Listbox.Option>
                                    ))}
                                </div>
                            </Listbox.Options>
                        </Transition>
                    </div>
                </>
            )}
        </Listbox>
    )
}
